import { AccountFragment } from 'src/graphql/generated/graphql'

const willUseExpense = (account: AccountFragment): boolean =>
  account.expense.amount > 0

export default willUseExpense
